<template>
  <b-table
      :data="randomRawActivities"
      :loading="isLoading"
      ref="table"
      :row-class="(r, i) => getClassForOverMarkers(i, 'line')"
      :striped="false"
      draggable
      narrowed
      style="padding-top: 20px"
      :detailed="detailed"
      :show-detail-icon="false"
      detail-key="rawActivityId"
      @dragleave="dragleave"
      @dragover="dragover"
      @dragstart="dragstart"
      @drop="drop">
    >
    <template slot-scope="props">
      <b-table-column class="centered-table-content" field="nb" label="Nb">
        <div :class="getClassForOverMarkers(props.index, 'num')">{{ props.index + 1 }}</div>
      </b-table-column>
      <b-table-column class="centered-table-content" field="imgSrc" label="">
        <b-img :height="50" :img="getImageBackground(props.row.imgSrc)" :width="70"></b-img>
      </b-table-column>

      <b-table-column class="centered-table-content" field="name" label="Name">
        <a @click="toggle(props.row)">
          <strong>{{ props.row.name }}</strong>
        </a>
      </b-table-column>

      <b-table-column class="centered-table-content" field="question" label="Content">
        {{ props.row.content.question }}
      </b-table-column>

      <b-table-column centered class="centered-table-content" field="unlocked" label="Unlocked?">
        <b-button :icon-right="unlockIcon(props.row.content.unlocked_forced).icon"
                  :style="'color: ' + unlockIcon(props.row.content.unlocked_forced).style"
                  size="is-medium"
                  type="is-white"
                  @click="changeLockValue(props.row)"
        ></b-button>
      </b-table-column>

      <b-table-column centered class="centered-table-content" field="timer" label="Timer?">
        <b-button v-if="props.row.timeToAnswer"
                  :style="'color: #c55558'"
                  icon-right="clock-fast"
                  size="is-medium"
                  type="is-white"
                  @click="changeLockValue(props.row)"
        ></b-button>
      </b-table-column>

      <b-table-column centered class="centered-table-content" field="activityType" label="Type">
        <b-tag type="is-info">{{ props.row.activityType }}</b-tag>
      </b-table-column>
    </template>
    <template v-if="shuffleDisplay" slot="footer">
      <div class="has-text-right">
        <b-button icon-right="shuffle-variant" @click.prevent="shuffleActivities(randomRawActivities)">
          Shuffle
        </b-button>
      </div>
    </template>

    <template #detail="props">
      <article class="media">
        <div class="media-left" style="padding-right: 15px; font-size: smaller">
          <ul>
            <li><strong>Points:</strong> {{ props.row.points }}</li>
            <li><strong>Difficulty: </strong>{{ props.row.difficulty }}</li>
            <li><strong>Allowed attempts:</strong>
              {{ props.row.allowedAttempts ? props.row.allowedAttempts : '&infin;' }}
            </li>
            <li><strong>Image part of the question: </strong>
              <span>
                <b-icon :icon="formatBooleanWithIcon(props.row.imgPartOfTheQuestion).icon"
                        :type="formatBooleanWithIcon(props.row.imgPartOfTheQuestion).class"
                        size="is-small"></b-icon>
              </span></li>
          </ul>
        </div>
        <div class="media-content" style="font-size: smaller" v-html="getActivityContent(props.row)">
        </div>
      </article>
    </template>

  </b-table>
</template>

<script>
import BImg from './BImg'
import _ from 'lodash'
import rawActivityHelper from '../../helpers/rawActivities-helper'

export default {
  name: 'RawActivitiesRandomTable',
  components: {
    BImg,
  },
  props: {
    shuffleDisplay: false,
    randomRawActivities: null,
    maxLinesSelected: 0,
    detailed: false,
  },
  data() {
    return {
      isLoading: false,

      draggingRow: null,
      draggingRowIndex: null
    }
  },
  methods: {
    formatBooleanWithIcon: rawActivityHelper.formatBooleanWithIcon,
    unlockIcon: rawActivityHelper.unlockIcon,

    shuffleActivities(activity) {
      this.randomRawActivities = _.shuffle(activity)
      this.$emit('shuffled', this.randomRawActivities)
    },
    changeLockValue(activity) {
      for (let i = 0; i < this.randomRawActivities.length; i++) {
        if (this.randomRawActivities[i].rawActivityId === activity.rawActivityId) {
          this.randomRawActivities[i].content.unlocked_forced = !activity.content.unlocked_forced
        }
      }
    },
    getClassForOverMarkers(i, type) {
      if (i > this.maxLinesSelected) {
        return type === 'line' ? 'is-gris' : 'grey-round-white-text'
      } else {
        return type === 'line' ? '' : 'red-round-white-text'
      }
    },
    getImageBackground(img) {
      return 'background-image:url(' + img ? img : this.defaultImgSrc + ');'
    },
    getActivityContent(activity) {
      return rawActivityHelper.displayContentForActivityType(activity, false)
    },
    toggle(row) {
      this.$refs.table.toggleDetails(row)
    },
    dragstart(payload) {
      this.draggingRow = payload.row
      this.draggingRowIndex = payload.index
      payload.event.dataTransfer.effectAllowed = 'copy'
    },
    dragover(payload) {
      payload.event.dataTransfer.dropEffect = 'copy'
      payload.event.target.closest('tr').classList.add('is-selected')
      payload.event.preventDefault()
    },
    dragleave(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      payload.event.preventDefault()
    },
    drop(payload) {
      payload.event.target.closest('tr').classList.remove('is-selected')
      const droppedOnRowIndex = payload.index
      this.randomRawActivities.splice(droppedOnRowIndex, 0, this.randomRawActivities.splice(this.draggingRowIndex, 1)[0])

      this.$emit('shuffled', this.randomRawActivities)
    }
  }
}
</script>

<style>
tr.is-gris {
  background: #e8eff4;
  font-style: italic;
}

.red-round-white-text {
  background: #c55558;
  border-radius: 15px;
  text-align: center;
  font-weight: bold;
  color: #eaeaea;
}

.grey-round-white-text {
  background: darkgrey;
  border-radius: 15px;
  text-align: center;
  font-weight: bold;
  color: #eaeaea;
}
</style>
